<template>
    <div class="pages message-page" v-cloak>
        <headerView></headerView>

        <div class="viewItem contact-view" id="contact">
 
            <div class="cbox-left">
                <div class="title-inner">
                    <p class="title-en">Contact Information</p>
                    <p class="title-cn">联系信息</p>
                </div>

                <div class="line"></div>

                <div class="info-wrap">
                    <p class="name">{{companyData.companyName}}</p>
                    <div class="richText" v-if="companyData.contact">
                        <div class="icon-wrap">
                            <img class="icon" src="../../assets/images/icon-phone.png" />
                        </div>
                        <span>{{$t('phone2')}}：{{companyData.contact}}</span>
                    </div>
                    <div class="richText" v-if="companyData.fax">
                        <div class="icon-wrap">
                            <img class="icon" src="../../assets/images/icon-fax.png" />
                        </div>
                        <span>{{$t('fax')}}：{{companyData.fax}}</span>
                    </div>
                    <div class="richText" v-if="companyData.email">
                        <div class="icon-wrap">
                            <img class="icon" src="../../assets/images/icon-email.png" />
                        </div>
                        <span>{{$t('email')}}：{{companyData.email}}</span>
                    </div>
                    <div class="richText" v-if="companyData.address">
                        <div class="icon-wrap">
                            <img class="icon" src="../../assets/images/icon-address.png" />
                        </div>
                        <span>{{$t('address')}}：{{companyData.address}}</span>
                    </div>


                </div>

            </div>
            <div class="cbox-right">
                <div id="mapcontainer"></div>



            </div>



        </div>

        <div class="message-view" id="message">
            <div class="viewItem">
                <div class="title">
                    <titleModule :modata="{WContent:{enTitle:'Online Message',cnTitle:'在线留言'}}"></titleModule>
                </div>

                <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="0" class="demo-ruleForm">
                    <el-row>
                        <el-col :xs="24" :sm="12" class="mgb10">
                            <el-form-item prop="name">
                                <el-input placeholder="请输入姓名" v-model="ruleForm.name" />
                            </el-form-item>

                        </el-col>

                        <el-col :xs="24" :sm="12" class="mgb10 f-r">
                            <el-form-item prop="phone">
                                <el-input placeholder="请输入手机号" v-model="ruleForm.phone"></el-input>
                            </el-form-item>

                        </el-col>

                    </el-row>
                    <el-row>

                        <el-col :xs="24" :sm="12" class="mgb10">
                            <el-form-item prop="name">
                                <el-input placeholder="请输入邮箱" v-model="ruleForm.email"></el-input>
                            </el-form-item>

                        </el-col>

                        <el-col :xs="24" :sm="12" class="mgb10 f-r">
                            <el-form-item prop="name">
                                <el-input placeholder="请输入地址" v-model="ruleForm.address"></el-input>
                            </el-form-item>

                        </el-col>

                    </el-row>
                    <el-form-item prop="messageContent">
                        <el-input type="textarea" :rows="6" placeholder="请输入留言内容"
                            v-model="ruleForm.messageContent"></el-input>
                    </el-form-item>



                    <div class="btn-wrap">
                        <a href="javascript:;" class="btn" @click="handerSubmit" v-loading="btnload">提交</a>
                    </div>


                </el-form>


            </div>


        </div>



        <footView></footView>
    </div>
</template>

<script>
var map = null;
import { addMessage } from "@/request/api";
import titleModule from "@/components/Custom/Title";
import { mapGetters } from "vuex";

export default {
    name: "messageIndex",
    components: { titleModule },
      computed: {
    ...mapGetters(
      { modata: 'footData', companyData: 'configData', runenv: 'runenv' },
    ),
  },
    data() {
        return {
            marker_1: require("../../assets/images/marker_1.png"),


            btnload: false,
            ruleForm: {
                name: '',
                phone: '',
                email: '',
                address: '',
                messageContent: '',
            },

            rules: {
                phone: [
                    { required: true, message: '请输入手机号', trigger: 'blur' },
                    { pattern: /^1[3-9]\d{9}$/, message: '请输入有效的手机号', trigger: 'blur' }
                ],
                messageContent: [
                    { required: true, message: '留言内容不能为空', trigger: 'blur' }
                ],
            }

        };
    },
  watch:{
    "companyData":function(newval){
        if(newval){
            this.pageLoad=1;
             this.setMapCenter();
             this.initLoad();
        }
    },
  },

    mounted() {
        var script = document.createElement("script");
        script.type = "text/javascript";
        script.src =
        "https://map.qq.com/api/js?v=2.exp&key=KX7BZ-MQ46V-6OAPN-5QISF-JOGXK-CFFJN&callback=initMap";
        document.body.appendChild(script);
        window.initMap = () => {
          this.initMap();
        };





    },
    created() { },
    methods: {
    initLoad(){
        let that=this;
        // hash 锚点滚动兜底(数据加载完后,再次尝试)
        if (that.$route.hash == "#message") {
            that.$nextTick(() => {
            const el = document.querySelector(that.$route.hash)
            if (el) {
                const headerEl = document.querySelector('header')
                const headerHeight = headerEl ? headerEl.offsetHeight : 0
                const top = el.getBoundingClientRect().top + window.scrollY - headerHeight
                window.scrollTo({ top: Math.max(0, top), })// behavior: 'smooth'
            }
            })
        }
    },


    //地图
    initMap() {
      let that = this;
      var container = document.getElementById("mapcontainer");
      map = new qq.maps.Map(container, {
        // draggableCursor: "crosshair",
        zoom: 12
      });
      new qq.maps.Label({
        map: map,
        offset: new qq.maps.Size(15, -12),
        draggable: false,
        clickable: false
      });
       this.setMapCenter();
    },

    setMapCenter() {
      let that = this;
      let companyData=this.companyData||null;
      
      if (map && companyData) {
        let location=companyData.location||"";
        location=location.split(",");
        let latitude =location[0]||23.277476;
        let longitude =location[1]||113.315833;
        var center = new qq.maps.LatLng(latitude, longitude);
        map.setCenter(center);
        if (location[1]) {
          var anchor = new qq.maps.Point(10, 10),
            size = new qq.maps.Size(32, 32),
            origin = new qq.maps.Point(0, 0),
            icon = new qq.maps.MarkerImage(that.marker_1, size, origin, anchor);
         
          new qq.maps.Marker({
            icon: icon,
            position: center,
            map: map
          });
        }
      }
    },

    showMarkers() {
      let that = this;
      this.clearOverlays(that.markers); //清除marker
      if (that.infoWin) {
        that.infoWin.close();
        that.infoWin = null;
      }

      var pois = this.list;
      that.infoWin = new qq.maps.InfoWindow({
        map: map
      });
      for (var i = 0, l = pois.length; i < l; i++) {
        (function(n) {
          var anchor = new qq.maps.Point(15, 3),
            size = new qq.maps.Size(30, 30),
            origin = new qq.maps.Point(0, 0),
            icon = new qq.maps.MarkerImage(that.marker_2, size, origin, anchor);

          var marker = new qq.maps.Marker({
            icon: icon,
            position: new qq.maps.LatLng(
              pois[n].latitude,
              pois[n].longitude
            ),
            map: map
          });
          //markStoreImg

          marker.setTitle(i + 1);
          that.markers.push(marker);
          //点击检索出来的结果
          qq.maps.event.addListener(marker, "click", function() {
            that.showList=false;
            that.infoWin.open();
            var htmlstr=`<div style="color: rgba(18, 21, 26, 0.6);width: 402px; padding: 16px 0;">
                        <img
                          style="border-radius: 8px;width: 100%;height: 226px;"
                          src="${pois[n].masterUrlStr}"
                          alt
                        />
                        <div style=" color: #12151a;font-size: 16px;margin-top: 8px;">${pois[n].name}</div>
                        <div style="line-height: 20px;margin: 8px 0 6px;word-break: break-all;">${pois[n].addressContent}</div>
                        <div class="info">
                          <span>${that.$t('store_phone')}: ${pois[n].phone}</span>
                          <span style="margin: 0 10px;">|</span>
                          <span>${that.$t('store_time')}: ${pois[n].openTime}</span>
                        </div>
                      </div>`
             that.infoWin.setContent(htmlstr)
            that.infoWin.setPosition(
              new qq.maps.LatLng(pois[n].latitude, pois[n].longitude)
            );
          });
        })(i);
      }
    },


        handerSubmit() {
            var _self = this;
            if (_self.btnload) {
                return
            }
            this.$refs["ruleForm"].validate((valid) => {
                if (valid) {
                    _self.btnload = true;
                    addMessage(this.ruleForm).then(res => {
                        if (res.code == 200) {
                            _self.$message({
                                message: '留言成功！',
                                type: 'success'
                            });
                            this.ruleForm = {
                                name: '',
                                phone: '',
                                email: '',
                                address: '',
                                messageContent: '',
                            }
                        } else {
                            _self.$message({
                                message: res.message || "留言失败，请稍后重试",
                                type: 'success'
                            });
                        }
                    }).finally(() => {
                        _self.btnload = false;
                    })

                } else {

                    return false;
                }
            });



        },

    },


};
</script>

<style scoped lang="scss">
.f-r {
    float: right;
}

// 联系我们
#mapcontainer{
    width: 100%;height: 100%;
}
.contact-view{
    display: flex;
    flex-wrap: wrap;
    flex-direction: row;
    width: 90%;
    background_radio: 1;
    display-radio: flex;
    max-width: 1600px;
    margin:0 auto;
    padding: 5% 0;

 .cbox-left{
    flex: 0 0 40%;
    align-self: center;
 }
 .cbox-right{
    flex: 1;
    max-width: 100%;
    max-height: 100%;
 }

.title-en {
    line-height: normal;
    font_radio: 2;
    display-radio: 1;
    font-size: 20px;
    font-family: "pingfang medium";
    text-align: left;
    color: rgba(1, 79, 164, 1);
}
.title-cn {
    line-height: normal;
    font_radio: 2;
    display-radio: 1;
    font-size: 42px;
    font-family: "pingfang heavy";
    text-align: left;
}
.line{
    display-radio: 1;
    border-top-style: dotted;
    border-top-width: 1px;
    border-top-color: rgba(179, 179, 179, 1);
    line_radio: 1;
    margin:18px 30px 18px 0;
}
.info-wrap{
    font-size: 20px;
    color: #464646;
}
.info-wrap .name {
    line-height: normal;
    font_radio: 2;
    display-radio: 1;
    font-size: 28px;
    font-family: "PINGFANG HEAVY";
    font-weight: normal;
    margin-bottom: 30px;
    color: rgba(56, 56, 56, 1);
}
.richText{
    display: flex;
    align-items: center;
    margin-bottom: 18px;
}
.icon-wrap{
    display: inline-block;
    vertical-align: middle;
    background-color: var(--main-color);
    border-radius: 30px;
    width: 48px;
    height: 48px;
    text-align: center;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    margin-right: 14px;
}
.icon-wrap .icon{
    width: 24px;
    height: auto;
}


}



// 留言

@media only screen and (min-width: 768px) {
    .el-col-sm-12 {
        width: 49%;
    }

}

.message-view {
    background-color: rgba(240, 245, 251, 1);
    padding: 4% 0 5%;
    .title{
        margin-bottom: 3%;
    }

}

.btn-wrap {
    margin: 30px auto 20px;
    text-align: center;

    .btn {
        display: inline-block;
        position: relative;
        overflow: hidden;
        text-align: center;
        box-sizing: border-box;
        padding: 10px 8px;
        width: 180px;
        background-color: #fff;
        border-style: solid;
        border-color: var(--main-color);
        border-width: 2px;
        color: var(--main-color);
        font-size: 18px;
        border-radius: 45px;
        position: relative;
    }

    .btn:hover {
        background-color: var(--main-color);
        color: #fff;
    }

    .btn:before {
        content: "";
        position: absolute;
        display: block;
        transition: all .6s;
        width: 100%;
        height: 0;
        border-radius: 50%;
        left: 50%;
        top: 50%;
        padding-top: 100%;
        transform: translateX(-50%) translateY(-50%);
    }

    .btn:hover:before {
        animation: btn_bg .75s;
        z-index: 1
    }

    @keyframes btn_bg {
        0% {
            background: rgba(0, 0, 0, .25);
            transform: translateX(-50%) translateY(-50%) scale(0)
        }

        to {
            background: 0 0;
            transform: translateX(-50%) translateY(-50%) scale(1)
        }
    }




}

@media screen and (max-width: 768px) {

    .contact-view{
        width: 92%;
        flex-direction: column;
        padding-top: 1%;
        .title-cn{
            font-size: 38px;
        }
        .cbox-left{
            flex: 1;
            align-self: start;
        }
        .richText{
            margin-bottom: 12px;
        }
       .icon-wrap{
            width: 40px;
            height: 40px;
            margin-right: 10px;
        }
        .icon-wrap .icon{
            width: 20px;
            height: auto;
        }
        .cbox-right{
            width: 100%;
        }
        #mapcontainer{
            height: 300px;
        }

   
    }
         .btn-wrap .btn{
            width: 50%;
        }
}


</style>
<style>
.message-page {

    .el-input__inner {
        border-width: 2px;
        height: 52px;
        font-size: 16px;
        line-height: 46px;
    }

    .el-textarea__inner {
        border-width: 2px;
    }
}



</style>